
export const CLOSE_CONFIRMATION_MODAL = 'CLOSE_CONFIRMATION_MODAL';
export const closeConfirmationModal = () => ({type: CLOSE_CONFIRMATION_MODAL});

export const OPEN_CONFIRMATION_MODAL = 'OPEN_CONFIRMATION_MODAL';
export const openConfirmationModal = ({text, callback, confirmCheckbox, btn1, btn2}) => ({
    type: OPEN_CONFIRMATION_MODAL,
    payload: {text, callback, confirmCheckbox, btn1, btn2}
});



// WEBPACK FOOTER //
// ./src/components/confirmation-modal/ConfirmationModalActions.js